import { AuthLayout, ForgotPasswordForm } from '../components/features/auth';

export function ForgotPasswordPage() {
  return (
    <AuthLayout
      title="Reset password"
      subtitle="We'll help you get back on track"
    >
      <ForgotPasswordForm />
    </AuthLayout>
  );
}
